import { render, staticRenderFns } from "./InactiveScheme.vue?vue&type=template&id=18a9f17c&scoped=true&"
import script from "./InactiveScheme.vue?vue&type=script&lang=js&"
export * from "./InactiveScheme.vue?vue&type=script&lang=js&"
import style0 from "./InactiveScheme.vue?vue&type=style&index=0&id=18a9f17c&prod&lang=scss&scoped=true&"
import style1 from "./InactiveScheme.vue?vue&type=style&index=1&id=18a9f17c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a9f17c",
  null
  
)

export default component.exports